import React, { useState, useEffect } from "react";
import Select from './../components/Select';
import {currentPageInfo, tracRudderStackkEvent} from "../../helper";
const KEY_TIRES_OPTIONS = {
  4: "4",
  3: "3",
  2: "2",
  1: "1",
};
const PopUpShopNow = ({
  isOpen,
  onClose,
  onCancel,
  onEdit,
  children,
  onBack,
  vehicleName,
  sendTireQuntityValue,
  simple_shop_url,
  z3pClientName
}) => {
  const LOCAL_TireQuntityValue = "TireQuntityValue";
  const savedQty = localStorage.getItem(LOCAL_TireQuntityValue) || "4";
  const [errorMessage, setErrorMessage] = useState("");
  const [keyLocationOption, setKeyLocationOption] = useState(savedQty);
  const shopNowLink = localStorage.getItem("ShopNowHyperLink");
  const simpletire_url = "https://simpletire.com";
  const cleanedSimpleShopUrl = simple_shop_url?.endsWith("/")
    ? simple_shop_url.slice(0, -1)
    : simple_shop_url;
  useEffect(() => {
    if (isOpen) {
      const existingQty = localStorage.getItem(LOCAL_TireQuntityValue);
      if (!existingQty) {
        localStorage.setItem(LOCAL_TireQuntityValue, "4");
      }
    }
  }, [isOpen]);
  const handleChange = (tireQuntityValue) => {
    setKeyLocationOption(tireQuntityValue);
    sendTireQuntityValue(tireQuntityValue);
    if (tireQuntityValue !== "0" && tireQuntityValue !== "") {
      setErrorMessage("");
    }
    localStorage.setItem(LOCAL_TireQuntityValue, tireQuntityValue);
  };
  if (!isOpen) return null;
  return (
    <div style={styles.overlay}>
      <div style={styles.modalContainer}>
        <button style={styles.closeButton} onClick={onCancel} aria-label="Close">
          ×
        </button>
        <button className="text-back" style={styles.backButton} onClick={onBack} aria-label="Back">
          <img src="/static/img/ic-back.png" alt="Back" style={styles.backIcon} />Back
        </button>
        {children}
        <div style={styles.modalContent}>
          <label className="text-vehicel-title">Vehicle</label>
          <div style={styles.vehicleContainer}>
            <label className="text-vehicel-name">{vehicleName.display_name}</label>
            <img
              src="/static/img/IconButton.png"
              alt="Edit"
              onClick={onEdit}
              style={styles.editIcon}
            />
          </div>
          <label className="text-how-many-tire">How many tires do you need installed?</label>
        </div>
        <label className="text-number-tire">Number of tires*</label>
        <Select
          id="keyLocationOption"
          name="keyLocationOption"
          value={keyLocationOption}
          onChange={(e) => handleChange(e.target.value)}
          required
        >
          {/* {Object.entries(KEY_TIRES_OPTIONS).map(([optionName, text]) => (
            <option key={optionName} value={optionName}>
              {text}
            </option>
          ))} */}
          {["4", "3", "2", "1"].map((value) => (
            <option key={value} value={value}>
              {KEY_TIRES_OPTIONS[value]}
            </option>
          ))}
        </Select>
        {errorMessage && <div style={styles.errorText}>{errorMessage}</div>}
        <label className="text-need-new-tire">Need new tires?</label>
        <label className="text-shop-new">
          Shop for new tires and schedule installation, all online with us.
        </label>
        <div style={styles.modalFooter}>
          <button
            className="btn-shop-now"
            style={styles.continueButton}
            onClick={() => {

              tracRudderStackkEvent('Tire_Install_Shopnow', {
                proname: z3pClientName,
                description: `User clicked Shop Now Button on Tire Installation Pop Up`,
                button_name: 'Shop Now'
              });
              const url =
                cleanedSimpleShopUrl !== null
                  ? `${cleanedSimpleShopUrl}${shopNowLink}`
                  : `${simpletire_url}${shopNowLink}`;
              window.open(url, "_blank", "noopener,noreferrer");
            }}
          >
            Shop now
          </button>
        </div>
        <div style={styles.modalFooter}>
          <button
            style={styles.noThanksButton}
            onClick={() => {
              if (keyLocationOption === "0" || keyLocationOption === "") {
                setErrorMessage("Quantity is required");
              } else {
                setErrorMessage("");
                onClose();
              }
            }}
          >
            No, thanks. Continue.
          </button>
        </div>
      </div>
    </div>
  );
};
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContainer: {
    background: "white",
    width: "335px",
    height: "580px",
    borderRadius: "8px",
    padding: "20px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  modalContent: {
    marginTop: "50px",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "10px",
    background: "transparent",
    border: "none",
    fontSize: "25px",
    color: "#333",
    cursor: "pointer",
  },
  label: {
    fontSize: "14px",
    fontWeight: "450",
    color: "#637381",
    marginBottom: "5px",
  },
  vehicleContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
  },
  vehicleName: {
    fontSize: "14px",
    fontWeight: "450",
    color: "#212B36",
    marginRight: "8px",
    lineHeight: "22px",
    fontfamily: "Circular Std",
  },
  errorText: {
    color: "red",
    fontSize: "14px",
    marginTop: "-10px",
  },
  editIcon: {
    width: "30px",
    height: "24px",
    cursor: "pointer",
    marginLeft: "5px",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  continueButton: {
    backgroundColor: "white",
    color: "#192B35",
    borderRadius: "5px",
    cursor: "pointer",
    height: "48px",
    width: "295px",
    border: "1px solid #4B819F7A",
    fontWeight: "700",
  },
  noThanksButton: {
    backgroundColor: "#192B35",
    color: "#FFFFFF",
    borderRadius: "5px",
    cursor: "pointer",
    height: "48px",
    width: "295px",
    border: "1px solid #4B819F7A",
    fontWeight: "700",
    fontfamily: "Circular Std",
  },
  backButton: {
    position: "absolute",
    top: "20px",
    left: "5px",
    background: "transparent",
    border: "none",
    fontSize: "14px",
    color: "#637381",
    cursor: "pointer",
    fontWeight: "450",
    display: "flex",
    alignItems: "center",
    fontfamily: "Circular Std",
  },
  backIcon: {
    width: "24px",
    height: "24px",
    marginRight: "1px",
  },
};
export default PopUpShopNow;